import { motion } from "framer-motion";
import { LASERCUT } from "@/constants/testIds";

const STEPS = [
  {
    n: "01",
    title: "Cutting",
    body: "Plat besi dipotong presisi dengan laser & plasma cutting sesuai desain motif custom.",
    img: "https://static.prod-images.emergentagent.com/jobs/13f79864-2d72-45f5-9e64-8b6b2b57a89d/images/f6a0ca98b4b80c5604f80694620e01aabe58dbbcd2a267c5232a9b9c3c345661.jpeg",
  },
  {
    n: "02",
    title: "Welding",
    body: "Komponen dirangkai dan dilas oleh tangan terlatih menjadi struktur yang kokoh.",
    img: "https://static.prod-images.emergentagent.com/jobs/13f79864-2d72-45f5-9e64-8b6b2b57a89d/images/54aac9a9d2eb4a656c735a2162654eb4e83c52a862228479bc904f0110f6f909.jpeg",
  },
  {
    n: "03",
    title: "Finishing",
    body: "Powder coating tahan cuaca diaplikasikan agar warna & struktur awet bertahun-tahun.",
    img: "https://static.prod-images.emergentagent.com/jobs/13f79864-2d72-45f5-9e64-8b6b2b57a89d/images/ce853e17a9b3099b81170b463f773bdb58f0081d1fcf50cae014ba09a3b3d880.jpeg",
  },
];

export const Process = () => (
  <section id="proses" className="relative bg-iron py-24 md:py-36 px-6 md:px-12 lg:px-24">
    <div className="max-w-2xl mb-16">
      <span className="text-xs uppercase tracking-[0.25em] text-brass">Proses Produksi</span>
      <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl tracking-tight text-chromed mt-4">
        Cutting → Welding → Finishing
      </h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-6">
      {STEPS.map((s, i) => (
        <motion.div
          key={s.n}
          data-testid={LASERCUT.processStep(s.n)}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: i * 0.15 }}
          className="group relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden arch-frame border border-linecol">
            <img
              src={s.img}
              alt={s.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
            <span className="absolute top-5 left-5 font-heading text-4xl text-brass">{s.n}</span>
          </div>
          <h3 className="font-heading text-xl md:text-2xl text-chromed mt-6 mb-2">{s.title}</h3>
          <p className="text-chromed/60 leading-relaxed">{s.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
